import _merge from 'lodash/merge';
import { Lightning } from '@lightningjs/sdk';
import Store from 'lightningjs-redux';
import { getInitialStyle } from './gdprBanner.style';
import { Button } from '../../../tornado/button/button.component';
import {
  pressGdprNoticeConsentAllButton,
  pressGdprNoticeDeclineAllButton,
} from '../../../../logic/gdprNotice/gdprNotice.actions';
import { t } from '../../../i18n';
import { PRIVACY_SELECT, PRIVACY_CONSENT_ALL, PRIVACY_DECLINE_ALL } from '../../gdprBanner.constants';
import { SHOW_PRIVACY_SETTINGS_SIGNAL } from '../../../cookieConsent/cookieConcent.constants';

export class GdprBanner extends Lightning.Component {
  static _template() {
    return _merge(
      {
        Description: {
          text: {
            text: t('gdprNotice.description'),
          },
        },
        ButtonsRow: {
          AcceptAll: {
            type: Button,
            label: t('gdprNotice.ok'),
            action: PRIVACY_CONSENT_ALL,
          },
          Settings: {
            type: Button,
            label: t('gdprNotice.parameters'),
            action: PRIVACY_SELECT,
          },
          DeclineAll: {
            type: Button,
            label: t('gdprNotice.decline'),
            action: PRIVACY_DECLINE_ALL,
          },
        },
      },
      getInitialStyle(),
    );
  }

  _construct() {
    this._index = 0;
  }

  _build() {
    this._buttons = this.tag('ButtonsRow').children;
  }

  _setIndex(index = this._index) {
    this._index = index;
  }

  _focus() {
    this._setIndex();
  }

  _unfocus() {
    this._setIndex(0);
  }

  _getFocused() {
    return this._buttons[this._index];
  }

  _handleEnter() {
    switch (this._getFocused().action) {
      case PRIVACY_CONSENT_ALL:
        Store.dispatch(pressGdprNoticeConsentAllButton());

        return true;

      case PRIVACY_DECLINE_ALL:
        Store.dispatch(pressGdprNoticeDeclineAllButton());

        return true;

      case PRIVACY_SELECT:
        this.signal(SHOW_PRIVACY_SETTINGS_SIGNAL);

        return true;

      default:
        return false;
    }
  }

  _handleRight() {
    if (this._index < this._buttons.length - 1) {
      this._setIndex(this._index + 1);

      return true;
    }

    return true;
  }

  _handleBack() {
    return true;
  }

  _handleLeft() {
    if (this._index > 0) {
      this._setIndex(this._index - 1);

      return true;
    }

    return true;
  }
}
